import React, { useContext, useEffect } from "react";
import { Button, Table, Icon,  Container } from "semantic-ui-react";
import * as XLSX from "xlsx";
import { IBdodJob } from "../../../app/models/bdodjob";
import BdodJobStore from "../../../app/stores/bdodjobsStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";

const BdodJobCreateForm: React.FC<RouteComponentProps> = ({
  match,
  history,
}) => {
  const bdodjobStore = useContext(BdodJobStore);
  const {
    createBdodJob,
    submitting,
    importBdodJobs,
    bdodjobList,
    clearBdodJob,
  } = bdodjobStore;

  useEffect(() => {
    return () => {
      clearBdodJob();
    };
  }, []);

  const handleSubmit = () => {
    createBdodJob(bdodjobList).then(() =>
      history.push(`/financemanagement/bdodjob`)
    );
  };

  const readExcel = (file: any) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsBinaryString(file[0]);
      fileReader.onload = () => {
        const bufferArray = fileReader.result;
        const wb = XLSX.read(bufferArray, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);

        resolve(data);
      };

      fileReader.onerror = (error) => {
          reject(error);
      };
    });

    promise.then((data) => {
        importBdodJobs(data);
    }).catch((error) => console.log(error));
  };

  var i = 0;

  return (
      <Container fluid>
          <Button as="label" htmlFor="file" type="button" color="blue" size="small">
          <Icon name='file excel' />
              Import
          </Button>
          <input type="file" id="file" accept=".xlsx, .xls, .csv" hidden
          onChange={(e) => {
              const file = e.target.files;
              readExcel(file);
          }}
          />
          <Button 
          loading={submitting}
          floated='right'
          color='green'
          onClick={handleSubmit}
          content='Submit'
          />
          <Table celled>
        <Table.Header>
          <Table.Row>
          <Table.HeaderCell>No.</Table.HeaderCell>
          <Table.HeaderCell>Work Number</Table.HeaderCell>
          <Table.HeaderCell>Location</Table.HeaderCell>
          <Table.HeaderCell>Date</Table.HeaderCell>
            <Table.HeaderCell>Tech</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Payment</Table.HeaderCell>
            <Table.HeaderCell>Amount</Table.HeaderCell>
            <Table.HeaderCell>Remark</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {bdodjobList.map(bdodjob => {
              i = i + 1;
          return     <Table.Row key={bdodjob.id}>
              <Table.Cell>
                {i}
              </Table.Cell>
              <Table.Cell>{bdodjob.workNumber}</Table.Cell>
              <Table.Cell>{bdodjob.location}</Table.Cell>
              <Table.Cell>{bdodjob.date.substr(8,2) + '/' +
               bdodjob.date.substr(5,2) + '/' + bdodjob.date.substr(0,4)}</Table.Cell>
              <Table.Cell>{bdodjob.tech}</Table.Cell>
              <Table.Cell>{bdodjob.status}</Table.Cell>
              <Table.Cell>{bdodjob.payment}</Table.Cell>
              <Table.Cell>{bdodjob.amount}</Table.Cell>
              <Table.Cell>{bdodjob.remark}</Table.Cell>
            </Table.Row>;
             })}
        </Table.Body>
      </Table>
      </Container>
  );
};

export default observer(BdodJobCreateForm);
